import styled from 'styled-components';

export const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;
